<template>
  <div id="app">
    <div class="app-content">
      <!-- start: TOP NAVBAR -->
      <!-- end: TOP NAVBAR -->
      <div class="main-content">
        <div v-show="content_loading" style="text-align: center; height: 100vh;"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
        <iframe id="iframe" allowvr="yes" name="vrview" v-show="!content_loading" v-on:load="contentLoaded" :src="'course_files/' + content" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from './components/Menu.vue'
import ProgressBar from './components/ProgressBar.vue'

function system_pages_builder(menu_items, pages_result, level_0_index, level_1_index, level_2_index, level_3_index, deep_level) {
  
  for(let i = 0; i < menu_items.length; i++) {

    level_0_index = deep_level === 0 ? i : level_0_index;
    level_1_index = deep_level === 1 ? i : level_1_index;
    level_2_index = deep_level === 2 ? i : level_2_index;
    level_3_index = deep_level === 3 ? i : level_3_index;

    if(Object.keys(menu_items[i]).includes('content')) {
      pages_result.push({
        title: menu_items[i].title,
        content: menu_items[i].content,
        level_0_index: level_0_index,
        level_1_index: level_1_index,
        level_2_index: level_2_index,
        level_3_index: level_3_index,
        deep_level: deep_level
      });
    }

    if(Object.keys(menu_items[i]).includes('menu_items')) {
      let new_level = deep_level + 1;
      system_pages_builder(menu_items[i].menu_items, pages_result, level_0_index, level_1_index, level_2_index, level_3_index, new_level);
    }

  }
  return pages_result;
  
}

let pages_index = 0;
function system_pages_add_page_indexes(menu_items) {

  for(let i = 0; i < menu_items.length; i++) {

    if(Object.keys(menu_items[i]).includes('content')) {
      menu_items[i].page_index = pages_index;
      pages_index++;
    }

    if(Object.keys(menu_items[i]).includes('menu_items')) {
      system_pages_add_page_indexes(menu_items[i].menu_items);
    }

  }

  return menu_items;

}

import config_json from './../public/course_files/config.json';

//window.Main = Main.init();
export default {
  name: 'app',
  components: {
    Menu,
    ProgressBar
  },
  mounted() {
    console.log('Inicia Mounted');

    document.addEventListener('beforeunload', this.lmsExit);

    this.config.menu_items = system_pages_add_page_indexes(this.config.menu_items);

    this.system.pages = system_pages_builder(this.config.menu_items, [], null, null, null, null, 0);

    /*if(localStorage.bookmarks) {
      this.bookmarks = JSON.parse(localStorage.bookmarks);
    }

    if(localStorage.visited_pages) {
      this.visited_pages = JSON.parse(localStorage.visited_pages);
    }*/
    console.log('Termina Mounted');

  },
  watch: {
    /*bookmarks(pagesArray) {
      localStorage.bookmarks = JSON.stringify(pagesArray);
    },*/
    actual_page(page) {
      console.log('Watch actual_page', page);
      this.level_0_index = this.system.pages[page].level_0_index;
      this.level_1_index = this.system.pages[page].level_1_index;
      this.level_2_index = this.system.pages[page].level_2_index;
      this.level_3_index = this.system.pages[page].level_3_index;
    }
  },
  methods: {
    goToPage(index) {
      let can_go = false;

      if(index !== this.actual_page) {
        
        if(this.config.restricted_navigation === true && index > 0) {
          if(this.visited_pages.indexOf(index - 1) > -1) {
            can_go = true;
          }
        } else {
          can_go = true;
        }
      }

      if(can_go === true) {
        this.content_loading = true;
        this.actual_page = index;
        
        if(this.visited_pages.indexOf(index) === -1)
          this.visited_pages.push(index);
      }
    },
    goToHome() {
      console.log('goToHome()');
      this.goToPage(0);
    },
    goToEnd() {
      this.goToPage(this.system.pages.length - 1);
    },
    goNext() {
      if(this.system.pages.length - 1 > this.actual_page) {
        this.goToPage(this.actual_page + 1);
      } 
    },
    goPrev() {
      if(this.actual_page > 0) {
        this.goToPage(this.actual_page - 1);
      }
    },
    bookmark() {
      this.bookmarks.push(this.actual_page);
    },
    unBookmark() {
      this.bookmarks.splice(this.bookmarks.indexOf(this.actual_page),1);
    },
    restrictNavigation() {
      this.config.restricted_navigation = true;
    },
    freeNavigation() {
      this.config.restricted_navigation = false;
    },
    lmsSendScore(score) {
      this.evaluation_score = score;
      if(this.scormApi) {
        this.scormApi.LMSSetValue("cmi.core.score.raw", score);
        this.lmsCommit();
      }
    },
    lmsCourseCompleted() {
      if(this.scormApi) {
        if(Object.keys(this.config).includes('evaluation_min_score')) {
          if(this.evaluation_score >= this.config.evaluation_min_score) {
            console.log('%cMarcando curso como aprobado', 'background: #222; color: red');
            this.scormApi.LMSSetValue("cmi.core.lesson_status", "passed");
          } else {
            console.log('%cMarcando curso como reprobado', 'background: #222; color: red');
            this.scormApi.LMSSetValue("cmi.core.lesson_status", "failed");
          }
          
        } else {
          if(this.visited_pages.length === this.system.pages.length) {
            console.log('%cMarcando curso como completado', 'background: #222; color: red');
            this.scormApi.LMSSetValue("cmi.core.lesson_status", "completed");
          } else {
            console.log('%cMarcando curso como incomplete', 'background: #222; color: red');
            this.scormApi.LMSSetValue("cmi.core.lesson_status", "incomplete");
          }
        }
        
        this.lmsCommit();
      }
    },
    lmsCommit() {
      var strResult = this.scormApi.LMSCommit("");
      if (strResult == "false"){
        console.log('%cNo se está guardando', 'background: #222; color: red');
        alert("No esta guardando el curso, cierrelo y vuelvalo a abrir")  ;
      }
    },
    lmsStart() {

      // Inicializa
      if(this.scormApi) {
        this.scormApi.LMSInitialize("");
        var lesson_status = subitusPlayer.scormApi.LMSGetValue("cmi.core.lesson_status") ;
        
        if(lesson_status == "not attempted"){
          this.scormApi.LMSSetValue("cmi.core.lesson_status", "incomplete");
        }
      } 

      // Obtiene información de suspend_data
      if(this.scormApi) {
        var suspend_data = this.scormApi.LMSGetValue("cmi.suspend_data");
        if(suspend_data != '') {
          suspend_data = JSON.parse(suspend_data);
          this.visited_pages = suspend_data.visited_pages;
          this.bookmarks = suspend_data.bookmarks;
        }
      }

      // Navega a la primer página
      if(this.scormApi) {
        var page = this.scormApi.LMSGetValue("cmi.core.lesson_location");
        if(page != '')
          this.goToPage(parseInt(page));
      }
        

    },
    lmsExit() {
      var session_time = (new Date() - this.system.started_at) / 1000;
      var session_hours = Math.floor(session_time / 3600) % 24;
      if(session_hours < 10) session_hours = '0' + session_hours;
      session_time -= session_hours * 3600;
      var session_minutes = Math.floor(session_time / 60) % 60;
      if(session_minutes < 10) session_minutes = '0' + session_minutes;
      session_time -= session_minutes * 60;
      session_time = Math.round(session_time);
      if(session_time < 10) session_time = '0' + session_time;
      session_time = session_hours + ':' + session_minutes + ':' + session_time + '.00';

      this.lmsCourseCompleted();

      if(this.scormApi) {
        this.scormApi.LMSSetValue("cmi.core.lesson_location", this.actual_page);
        this.scormApi.LMSSetValue('cmi.core.session_time', session_time);

        var suspend_data = {
          visited_pages: this.visited_pages,
          bookmarks: this.bookmarks
        };
        this.scormApi.LMSSetValue('cmi.suspend_data', JSON.stringify(suspend_data));

        this.lmsCommit();
        this.scormApi.LMSFinish('') ;
      }
    },

    contentLoaded() {
      console.log('Content Loaded!');
      this.content_loading = false;
      var myIframe = document.getElementById('iframe');
      /*
      myIframe.onload = function () {
        var myElement = myIframe.contentWindow.document.getElementById('inicio');
        if (typeof(myElement) != 'undefined' && myElement != null)
        {
          setTimeout(function(){
            myIframe.contentWindow.scrollTo(0,myElement.offsetTop);
            if (/android|webos|iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase())) {
              var theminheight = Math.min(document.documentElement.clientHeight, window.screen.height, window.innerHeight);
              jQuery('html body #yourelementofchoise').css('height', theminheight);
            } else {
              jQuery('#app').height(jQuery(window).height());
            }
          }, 500);
        }
      }
      */
    }
  },
  computed: {
    content: function() {
      if(this.actual_page !== null)
        return this.system.pages[this.actual_page].content;
      else
        return 'intro.html';
    },
    isBookmarked: function() {
      return this.bookmarks.indexOf(this.actual_page) != -1;
    }
  },
  data () {
    return {
      config: config_json,
      bookmarks: [],
      visited_pages: [],
      actual_page: null,
      level_0_index: null,
      level_1_index: null,
      level_2_index: null,
      level_3_index: null,
      content_loading: false,
      system: {
        pages: [],
        started_at: new Date()
      },
      scormApi: false,
      evaluation_score: 0
    }
  } 
}
</script>

<style>
  body {
      font-family: "Roboto";
      font-weight: 400;
      font-style: normal;
  }

  h1, h2, h3, h4, h4, h6 {
      font-family: "Roboto";
      font-weight: 700;
      font-style: normal;
  }

  
  /*#sidebar {
    margin-top: 5px;
  }

  #sidebar .nav-user-wrapper {
    height: 135px;
  }

  header.navbar {
    height: 40px !important;
    min-height: 40px !important;
  }

  /*div.navbar-header {
    display: none !important;
  }*/

  /*.navbar-default {
    background-color: transparent !important;
  }

  .navbar .navbar-header {
    height: 40px !important;
  }

  .navbar .navbar-right > li > a {
    height: 40px;
    line-height: 46px;
  }

  .navbar .navbar-left > li > a {
    height: 40px;
    line-height: 46px;
  }

  .navbar .navbar-right > li:before {
    border: 0;
    width: 0;
  }

  .navbar .navbar-collapse {
    height: 40px !important;
  }

  .navbar .navbar-header a, .navbar .navbar-header button {
    line-height: 40px;
    height: 40px;
  }

  .navbar .navbar-left > li.sidebar-toggler-wrapper > div {
    line-height: 40px;
  }*/

  iframe {
    width: 100%;
    height: 100%;
    border: 0;  
  }

  .main-content {
    margin: 0px;
  }

  @media (max-width: 991px) {
    .main-content {
      height: calc(100vh) !important;
      min-height: calc(100vh) !important;
      padding-top: 0 !important;
    }

    div#app.app-sidebar-closed .navbar .navbar-collapse {
      margin-left: 0 !important;
    }

    header.navbar {
      top: 0 !important;
    }
  }

  @media (min-width: 992px) {
    .main-content {
      height: calc(100vh) !important;
      min-height: calc(100vh) !important;
    }

    #sidebar > div, #sidebar .sidebar-container {
      margin-left: 0 !important;
    }

    #sidebar > div nav:after {
      background: white;
      border-radius: 0 !important;
    }

  }

  .navbar .navbar-collapse .navbar-right > li > a > button.btnBookmarked i {
    color: #C82E29 !important;
  }

  header.navbar {
    top: 5px;
  }

  #app .app-content {
    height: calc(100%);
  }

  .app-sidebar-closed #sidebar {
    width: 0 !important;
  }

  .app-sidebar-closed .main-content {
    margin-left: 0 !important;
  }

  .app-sidebar-closed #sidebar:after {
    width: 0 !important;
  }

  .app-sidebar-closed .navbar .navbar-collapse {
    margin-left: 0 !important;
  }

  #sidebar > div nav > ul li {
    padding-left: 0 !important;
  }

  .media > .media-body > img {
    width: 100%;
    height: auto;
    padding: 5px;
  }

  /* LOADER */
  .lds-ring {
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid #207c7b;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #207c7b transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .small-bookmark {
    float: right;
    margin-right: 30px;
  }

</style>
